export const DATA_CHECK_BOX = [{label: 'Yes'}, {label: 'No'}];

export const DATA_SELECT = [
  {label: 'Less than 1 cigarette a day'},
  {label: 'Between 1 and 5 cigarettes a day'},
  {label: 'More than 6 cigarettes a day'},
];

export const PRODUCTS = [
  {
    value: 'althea',
    label: 'Althea',
  },
  {
    value: 'charlize',
    label: 'Charlize',
  },
  {
    value: 'cybelle',
    label: 'Cybelle',
  },
  {
    value: 'daphne',
    label: 'Daphne',
  },
  {
    value: 'diane-35',
    label: 'Diane-35',
  },
  {
    value: 'lady',
    label: 'Lady',
  },
  {
    value: 'liza',
    label: 'Liza',
  },
  {
    value: 'lizelle',
    label: 'Lizelle',
  },
  {
    value: 'marvelon',
    label: 'Marvelon',
  },
  {
    value: 'protec',
    label: 'Protec',
  },
  {
    value: 'trust',
    label: 'Trust',
  },
  {
    value: 'yasmin',
    label: 'Yasmin',
  },
  {
    value: 'yaz',
    label: 'Yaz',
  },
];

export const YES_OPTION = 'Yes';
export const NO_OPTION = 'No';

export type PopupPHCheckoutKey =
  | 'PROFILE'
  | 'USED_BIRTH_CONTROL'
  | 'CURRENTLY_MEDICATIONS'
  | 'MORE_INFORMATION'
  | 'MEDICAL_HISTORY';

export const POP_UP_PH_CHECKOUT_KEYS: Record<PopupPHCheckoutKey, PopupPHCheckoutKey> = {
  PROFILE: 'PROFILE',
  USED_BIRTH_CONTROL: 'USED_BIRTH_CONTROL',
  CURRENTLY_MEDICATIONS: 'CURRENTLY_MEDICATIONS',
  MORE_INFORMATION: 'MORE_INFORMATION',
  MEDICAL_HISTORY: 'MEDICAL_HISTORY',
};

export const PH_CHECKOUT_METHOD_KEY = 'PH_CHECKOUT';

export const DOB_KEY = 'DOB';

export const QUESTIONS_PARAMS = {
  USED_BIRTH_CONTROL: [
    {position: 0, selectedOption: 'Have you used birth control pills before?'},
    {position: 1, brandUsed: 'Which brand have you most recently used?'},
    {position: 2, issues: 'Any issues so far?'},
  ],
  CURRENTLY_MEDICATIONS: [
    {position: 0, selectedOption: 'Are you currently on any medications or herbal treatments?'},
    {position: 1, treatments: 'What are you taking?'},
  ],
  MORE_INFORMATION: [
    {position: 0, breastFeedingOptions: 'Are you breastfeeding?'},
    {position: 1, smokeOptions: 'Do you smoke?'},
    {position: 2, oftenSmoke: 'How often do you smoke on average?'},
  ],
  MEDICAL_HISTORY: [
    {
      position: 0,
      anyDiseaseHistoryOptions: 'Any history of blood clots, heart disease, hypertention, diabetes or migraines?',
    },
    {position: 1, selectedOption: 'Anything else about your medical history we should know?'},
    {position: 2, tellUsMore: 'Tell us more'},
  ],
};

export const QUESTIONS = {
  USED_BIRTH_CONTROL: {
    selectedOption: 'Have you used birth control pills before?',
    brandUsed: 'Which brand have you most recently used?',
    issues: 'Any issues so far?',
  },
  CURRENTLY_MEDICATIONS: {
    selectedOption: 'Are you currently on any medications or herbal treatments?',
    treatments: 'What are you taking?',
  },
  MORE_INFORMATION: {
    breastFeedingOptions: 'Are you breastfeeding?',
    smokeOptions: 'Do you smoke?',
    oftenSmoke: 'How often do you smoke on average?',
    anyDiseaseHistoryOptions: 'Any history of blood clots, heart disease, hypertention, diabetes or migraines?',
  },
  MEDICAL_HISTORY: {
    selectedOption: 'Anything else about your medical history we should know?',
    tellUsMore: 'Tell us more',
  },
};
